import { render, staticRenderFns } from "./AdminAppPaid2023ShowItem.vue?vue&type=template&id=3679167b&scoped=true"
import script from "./AdminAppPaid2023ShowItem.vue?vue&type=script&lang=js"
export * from "./AdminAppPaid2023ShowItem.vue?vue&type=script&lang=js"
import style0 from "./AdminAppPaid2023ShowItem.vue?vue&type=style&index=0&id=3679167b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3679167b",
  null
  
)

export default component.exports